"use client";

import { FC, useContext } from "react";
import { ImageGallery } from "components/organisms/ImageGallery";
import { AppContext } from "lib/contexts";
import * as Styled from "./UserGallery.styled";
export const UserGallery: FC = () => {
  const {
    state
  } = useContext(AppContext);
  return <Styled.UserGalleryWrapper data-sentry-element="unknown" data-sentry-component="UserGallery" data-sentry-source-file="index.tsx">
            {state.isLoggedIn && <ImageGallery gallerySubtitle="My Gallery" userGallery={true} />}
        </Styled.UserGalleryWrapper>;
};